import { ASSESSMENT_CATEGORIES, DOMAIN_ORDER } from '../config/constants';

/**
 * Format assessment results for copying
 * @param {Object} results - Assessment results object
 * @returns {string} Formatted text
 */
export const formatResultsForCopy = (results) => {
  let output = `FIM/FAM ASSESSMENT RESULTS\nGenerated: ${new Date().toLocaleString()}\n\n`;

  ASSESSMENT_CATEGORIES.forEach(({ prefix, title, labelReplace }) => {
    const items = Object.entries(results.results).filter(([key]) => key.startsWith(prefix));
    if (items.length > 0) {
      // Sort items according to DOMAIN_ORDER
      const sortedItems = items.sort((a, b) => {
        const indexA = DOMAIN_ORDER.indexOf(a[0]);
        const indexB = DOMAIN_ORDER.indexOf(b[0]);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
      
      output += `${title}\n`;
      sortedItems.forEach(([key, item]) => {
        const domainName = key.replace(labelReplace, '').replace(/_/g, ' ').toUpperCase();
        const score = item.userScore || item.score || '—';
        output += `${domainName}: ${score} - ${item.justification}\n`;
      });
      output += '\n';
    }
  });
  
  return output;
};

/**
 * Format single item for copying
 * @param {Object} item - Assessment item
 * @returns {string} Formatted text
 */
export const formatItemForCopy = (item) => {
  const score = item.userScore || item.score || '—';
  return `${item.name}: ${score}\nReasoning: ${item.justification}`;
};

/**
 * Format domain name from key
 * @param {string} key - Item key (e.g., 'selfcare_eating')
 * @param {string} prefix - Prefix to remove
 * @returns {string} Formatted domain name
 */
export const formatDomainName = (key, prefix) => {
  return key.replace(prefix, '').replace(/_/g, ' ').toUpperCase();
};

